import * as React from 'react'
import {useMemo} from 'react'

import CommonPopup from '../../../components/CommonPopup/CommonPopup'
import EditAgentPoolForm from '../../../components/EditAgentPoolForm/EditAgentPoolForm'

type Props = {
  onCreate: (arg0: void) => void
  onClose: (arg0: void) => void
  hidden: boolean
}
export default function CreateAgentPoolPopup({onCreate, onClose, hidden}: Props) {
  const handleClose = React.useCallback(() => {
    onClose()
  }, [onClose])
  return useMemo(
    () => (
      <CommonPopup
        hidden={hidden}
        onClose={handleClose}
        header={'New agent pool'}
        content={<EditAgentPoolForm onUpdate={onCreate} onClose={onClose} />}
      />
    ),
    [hidden, handleClose, onCreate, onClose],
  )
}
